(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-gift-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cc-gift-finder')) {
 customElements.define('cc-gift-finder',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;
   this.ready=true;
   this.addEventListener('change',()=>this.search());
   this.sortCards();
   this.update();
  }
  disconnectedCallback(){clearTimeout(this.searchTimer);}
  sortCards(occasion=''){
   const grid=this.querySelector('.cc-gift-grid');
   if(!grid)return;
   const score=card=>{
    const fallback=Number(card.dataset.priority)||30;
    if(!occasion)return fallback;
    const specific=Number(card.getAttribute('data-order-'+occasion))||99;
    return specific*100+fallback;
   };
   [...this.querySelectorAll('[data-gift]')]
    .sort((a,b)=>score(a)-score(b))
    .forEach(card=>grid.appendChild(card));
  }
  search(){
   clearTimeout(this.searchTimer);
   this.querySelector('.cc-gift-grid').hidden=true;
   this.querySelector('[data-status]').hidden=true;
   this.querySelector('[data-empty]').hidden=true;
   this.querySelector('[data-search]').hidden=false;
   this.searchTimer=setTimeout(()=>this.update(),2000);
  }
  update(){
   const occasion=this.querySelector('[data-occasion]:checked')?.value || '';
   const recipient=this.querySelector('[data-recipient]:checked')?.value || '';
   const active=Boolean(occasion||recipient);
   this.sortCards(occasion);
   this.querySelector('[data-search]').hidden=true;
   this.querySelector('.cc-gift-grid').hidden=!active;
   this.querySelector('[data-status]').hidden=!active;
   let count=0;
   this.querySelectorAll('[data-gift]').forEach(card=>{
    const matches=active&&(!occasion||card.getAttribute('data-occasion-'+occasion)==='true')&&(!recipient||card.getAttribute('data-recipient-'+recipient)==='true');
    card.hidden=!matches;card.dataset.rank='';if(matches){count++;card.dataset.rank=String(count);card.querySelector('[data-number]').textContent=count;}
   });
   this.querySelector('[data-count]').textContent=count;
   this.querySelector('[data-empty]').hidden=!active||count>0;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
